import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isVietnam } from 'Util/DataUtils';
import { collapsedFieldSidebarAction } from 'Actions/AppSettingsActions';
import Scrollbars from 'react-custom-scrollbars-2';
import BasicSection from './components/BasicSection';
import EditSection from './components/EditSection';
import FieldAddUpdateDrawer from './components/FieldAddUpdateDrawer';
import StorageSection from './components/StorageSection';

const TYPE = {
  BASIC: 'BASIC',
  EDIT: 'EDIT',
  STORAGE: 'STORAGE',
};

const FieldSidebar = () => {
  const sidebarRef = useRef(null);
  const scrollRef = useRef(null);
  const { fieldCollapsed, navCollapsed } = useSelector(state => state.settings);
  const [openUpdatePopup, setOpenUpdatePopup] = useState(false);
  const [fieldId, setFieldId] = useState(null);
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.authUser);
  const [type, setType] = useState(TYPE.BASIC);

  const goToBasic = useCallback(() => {
    setType(TYPE.BASIC);
    scrollRef.current.scrollToTop();
  }, []);

  const goToEdit = useCallback(() => {
    setType(TYPE.EDIT);
    scrollRef.current.scrollToTop();
  }, []);

  const goToStorage = useCallback(() => {
    setType(TYPE.STORAGE);
    scrollRef.current.scrollToTop();
  }, []);

  useEffect(() => {
    const handleClickOutside = event => {
      if (fieldCollapsed) return;
      if (openUpdatePopup || !sidebarRef.current) {
        return;
      }
      const isToggleButton = event.target.closest('[data-field-toggle="true"]');
      const isClickInsideSidebar = sidebarRef.current.contains(event.target);

      if (!isToggleButton && !isClickInsideSidebar) {
        dispatch(collapsedFieldSidebarAction(true));
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [dispatch, openUpdatePopup, fieldCollapsed]);

  useEffect(() => {
    if (!fieldCollapsed) {
      setType(TYPE.BASIC);
    }
  }, [fieldCollapsed]);

  return (
    <>
      <div
        ref={sidebarRef}
        className={`field-sidebar ${fieldCollapsed && 'collapse'}`}
        style={{
          position: 'absolute',
          zIndex: 1000,
          left: !isVietnam(user) ? '200px' : navCollapsed ? '68px' : '185px',
        }}
      >
        <Scrollbars
          ref={scrollRef}
          className='rct-scroll'
          autoHide
          autoHideDuration={100}
          style={{
            height: 'calc(var(--vh, 1vh) * 100 - 53px)',
          }}
        >
          {type === TYPE.BASIC && <BasicSection setOpenUpdatePopup={setOpenUpdatePopup} setFieldId={setFieldId} goToEdit={goToEdit} />}
          {type === TYPE.EDIT && <EditSection goToBasic={goToBasic} goToStorage={goToStorage} />}
          {type === TYPE.STORAGE && <StorageSection goToBasic={goToBasic} goToEdit={goToEdit} />}
        </Scrollbars>
      </div>
      <FieldAddUpdateDrawer
        open={openUpdatePopup}
        onClose={() => {
          setOpenUpdatePopup(false);
          setFieldId(null);
        }}
        fieldId={fieldId}
      />
    </>
  );
};

export default FieldSidebar;
